import { isTruthy, mapToMap } from '@togglecorp/fujs';
import produce from 'immer';

import * as types from '#constants/types';
import * as Type from './types';
import initialState from './initialState';

// ACTION CREATORS

export function setProjectsAction(
    projects: types.Project[] | undefined,
) {
    return {
        type: Type.DomainType.SET_PROJECTS,
        projects,
    };
}

export function setHospitalsAction(
    hospitals: types.Hospital[] | undefined,
) {
    return {
        type: Type.DomainType.SET_HOSPITALS,
        hospitals,
    };
}

export function setPatientsAction(
    patients: types.Patient[] | undefined,
) {
    return {
        type: Type.DomainType.SET_PATIENTS,
        patients,
    };
}

export function setPatientsFilterAction(
    filters: types.PatientsFilter | undefined,
) {
    return {
        type: Type.DomainType.SET_PATIENTS_FILTER,
        filters,
    };
}

export function clearDataAction() {
    return {
        type: Type.DomainType.CLEAR_DATA,
    };
}

// REDUCERS

function setProjects(state: Type.DomainState, action: Type.SetProjectsAction) {
    const { projects } = action;

    return produce(state, (safeState) => {
        // eslint-disable-next-line no-param-reassign
        safeState.projects = projects;
    });
}

function setHospitals(state: Type.DomainState, action: Type.SetHospitalsAction) {
    const { hospitals } = action;

    return produce(state, (safeState) => {
        // eslint-disable-next-line no-param-reassign
        safeState.hospitals = hospitals;
    });
}

function setPatients(state: Type.DomainState, action: Type.SetPatientsAction) {
    const { patients } = action;

    return produce(state, (safeState) => {
        // eslint-disable-next-line no-param-reassign
        safeState.patients = patients;
    });
}

function setPatientsFilter(state: Type.DomainState, action: Type.SetPatientsFilterAction) {
    const { filters } = action;

    return produce(state, (safeState) => {
        // eslint-disable-next-line no-param-reassign
        safeState.patientsFilter = filters;
    });
}

function clearData() {
    return initialState;
}

export default function domainReducer(
    state = initialState,
    action: Type.DomainActionTypes,
): Type.DomainState {
    switch (action.type) {
        case Type.DomainType.SET_PROJECTS:
            return setProjects(state, action);
        case Type.DomainType.SET_HOSPITALS:
            return setHospitals(state, action);
        case Type.DomainType.SET_PATIENTS:
            return setPatients(state, action);
        case Type.DomainType.SET_PATIENTS_FILTER:
            return setPatientsFilter(state, action);
        case Type.DomainType.CLEAR_DATA:
            return clearData();
        default:
            return state;
    }
}
